import {
  type SalesforceConnectionResponse,
  type SalesforceConnectionStatus,
} from "@/features/salesforceIntegration/types";

/**
 * 接続状態APIのレスポンスから、画面の3表示（未接続 / 接続済み / 再認証が必要）を導出する。
 * 判定順は `needsReauthorization` → `isConnected` → 未接続（実装計画書6.2節の表のとおり）。
 */
export const deriveConnectionStatus = (
  connection:
    | Pick<SalesforceConnectionResponse, "isConnected" | "needsReauthorization">
    | undefined
): SalesforceConnectionStatus => {
  if (connection === undefined) {
    return "NOT_CONNECTED";
  }
  if (connection.needsReauthorization) {
    return "NEEDS_REAUTHORIZATION";
  }
  if (connection.isConnected) {
    return "CONNECTED";
  }
  return "NOT_CONNECTED";
};
